import React from "react";
import "./styles.css";

function Footer() {
    return (
        <footer>
            <p>&copy; 2023. Powered by <a href="https://github.com/lucyanovidio" target="_blank" title="Github de Lucyan">Lucyan Ovídio</a>.</p>
        </footer>        
    );
}

export default Footer;